import { render, staticRenderFns } from "./GuidedTourItem.vue?vue&type=template&id=077797eb&scoped=true&"
import script from "./GuidedTourItem.vue?vue&type=script&lang=ts&"
export * from "./GuidedTourItem.vue?vue&type=script&lang=ts&"
import style0 from "./GuidedTourItem.vue?vue&type=style&index=0&id=077797eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077797eb",
  null
  
)

export default component.exports